import React from 'react';
import { PropTypes } from 'prop-types';
import { LinkSmall } from '@styled';

const SectionHeader = ({ title, tutorialLabel, tutorialUrl }) => {
    const showTutorialLink = tutorialLabel && tutorialUrl;

    return (
        <>
            <h2
                style={{
                    fontWeight: 700,
                    backgroundColor: '#246EFF',
                    backgroundImage: 'url(/assets/modules/images/Header-Background.png)',
                }}
                className="mb-3 py-2 text-center text-white"
            >
                {title}
            </h2>

            {showTutorialLink && (
                <div className="flex justify-content-end mb-3">
                    <LinkSmall href={tutorialUrl} target="_blank">
                        {tutorialLabel}
                        {'>>'}
                    </LinkSmall>
                </div>
            )}
        </>
    );
};

SectionHeader.propTypes = {
    title: PropTypes.string.isRequired,
    tutorialLabel: PropTypes.string,
    tutorialUrl: PropTypes.string,
};

export default SectionHeader;
